var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-wrapper"},[_vm._m(0),_c('p',[_vm._v("版权所有 ©"+_vm._s(_vm.currentYear)+" 58同城基础平台研发中心")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("京ICP备10012705号-17")])])
}]

export { render, staticRenderFns }